export const GLOBAL_SEARCH_SECTION = {
  ALL: 'all',
  NETWORK: 'network',
  MY_NETWORK: 'mynetwork',
  FIRM: 'firm',
  REVIEW: 'review',
  JOB: 'job',
  INBOX: 'inbox',
};

export const GLOBAL_SEARCH_DATA_TYPE = {
  CANDIDATE: 'candidate',
  FIRM: 'firm',
  INTERVIEW: 'firm_interview',
  REVIEW: 'firm_review',
  OVERVIEW: 'firm_overview',
  PROCESS: 'process',
  MESSAGE: 'message',
};
